module.exports = __webpack_public_path__ + "img/tp_03.726d79bd.png";